import {ReactNode} from 'react';
import {DayOfWeekLayout} from '../../../graphql/generated/types';
import {useDayOfWeekLayoutQuery} from '../../../wrapper/tabWrapper';

interface Props {
  dayId: number;
  children: (data: DayOfWeekLayout) => ReactNode;
}

export const DayOfWeekLayoutContainer = ({dayId, children}: Props) => {
  const {data} = useDayOfWeekLayoutQuery({dayUid: dayId});

  if (!data) {
    return null;
  }

  return <>{children(data)}</>;
};
